import Question from 'models/common/form/question/Question';

export default class DeclarationQuestion extends Question {}
